// Main.js file.
// IIFE - Immediately Invoked Function Expression
(function (keinstil) {
    // The global jQuery object is passed as a parameter
    keinstil(window.jQuery, window, document);
}(function ($, window, document) {
    // The $ is now locally scoped
    // Listen for the jQuery ready event on the document


    //Hamburger menu trigger
    $('.hamburger').click(function () {
        $(this).toggleClass('is-active');
        $('.menu-main-menu-container, .menu-main-menu-english-container').slideToggle();
    });

    //Add Langugae swithcer short names
    $('.language-switcher ul .wpml-ls-item-de a span').html('DE');
    $('.language-switcher ul .wpml-ls-item-en a span').html('EN');
    $('.language-switcher ul .wpml-ls-item-ks a span').html('KS');

    //Animation for "Back to homepage"
    $('#backbutton').closest('a').hover(function () {
        $('#backbutton').addClass('hide');
        $('.back-try-again').addClass('show');
    },function () {
        $('#backbutton').removeClass('hide');
        $('.back-try-again').removeClass('show');
    });

    // Load current slide and current section when language is changed

    $('.wpml-ls-item a').click(function () {
        $(this).attr('href', function() {
            var activeSection = $('#fp-nav').find('.active').parent().index() + 1;
            if($('#fullpage section.active').find('.fp-slidesNav').length > 0) {
                var activeSlide = $('#fullpage section.active').find('.fp-slidesNav').find('.active').parent().index();
                return this.href + '#'+activeSection+'/'+activeSlide;
            }else {
                return this.href + '#'+activeSection;
            }
        });
    });

    //Change background source based on screen size


    window.onload = function () {
        if($(window).width() < 1024 && $(window).width() > 639){
            $("[data-anchor='projekte'] .fp-slidesContainer .slide").each(function () {
                var tablet_image = $(this).attr('data-tablet');
                $(this)[0].style.backgroundImage = "url("+tablet_image+")";
            });
        } else if($(window).width() < 640) {
            $("[data-anchor='projekte'] .fp-slidesContainer .slide").each(function () {
                var mobile_image = $(this).attr('data-mobile');
                $(this)[0].style.backgroundImage = "url("+mobile_image+")";
            });
        }

    };


    $('.project-link').click(function () {
        var pageURL = window.location.href;
        localStorage.setItem("url", pageURL);
    });

    // Back to projects function
    $('#backbutton-project').click(function (e) {
        e.preventDefault();
        location.replace(localStorage.getItem("url"));
    });



    //Scale for mobile

    var metaTag=document.createElement('meta');
    metaTag.name = "viewport";


    if($(window).width() < 1024) {
        metaTag.content = "width=device-width, initial-scale=0.6";
        document.getElementsByTagName('head')[0].appendChild(metaTag);
    }else {
        metaTag.content = "width=device-width, initial-scale=1.0";
        document.getElementsByTagName('head')[0].appendChild(metaTag);
    }


    // Init iziModal
    $('[id^=modal-text]').iziModal({
        title: '',
        subtitle: '',
        headerColor: 'transparent',
        background: 'transparent',
        theme: 'light',  // light
        icon: null,
        iconText: null,
        iconColor: '',
        rtl: false,
        width: '70%',
        top: null,
        bottom: null,
        borderBottom: false,
        padding: 20,
        radius: 0,
        zindex: 9999,
        iframe: false,
        iframeHeight: 400,
        iframeURL: null,
        focusInput: true,
        group: '',
        loop: false,
        arrowKeys: true,
        navigateCaption: true,
        navigateArrows: true, // Boolean, 'closeToModal', 'closeScreenEdge'
        history: false,
        restoreDefaultContent: false,
        autoOpen: 0, // Boolean, Number
        bodyOverflow: false,
        fullscreen: true,
        openFullscreen: false,
        closeOnEscape: true,
        closeButton: true,
        appendTo: 'body', // or false
        appendToOverlay: 'body', // or false
        overlay: true,
        overlayClose: true,
        overlayColor: 'rgba(0, 0, 0, 0.8)',
        timeout: false,
        timeoutProgressbar: false,
        pauseOnHover: false,
        timeoutProgressbarColor: 'rgba(255,255,255,0.5)',
        transitionIn: 'fadeIn',
        transitionOut: 'fadeOut',
        transitionInOverlay: 'fadeIn',
        transitionOutOverlay: 'fadeOut',
        onFullscreen: function(){},
        onResize: function(){},
        onOpening: function(){},
        onOpened: function(){},
        onClosing: function(){},
        onClosed: function(){},
        afterRender: function(){}
    });

    $('[id^=modal-video]').iziModal({
        title: '',
        subtitle: '',
        headerColor: 'transparent',
        background: 'transparent',
        theme: 'light',  // light
        icon: null,
        iconText: null,
        iconColor: '',
        rtl: false,
        width: 900,
        top: null,
        bottom: null,
        borderBottom: false,
        padding: 0,
        radius: 0,
        zindex: 9999,
        iframe: false,
        iframeHeight: 400,
        iframeURL: null,
        focusInput: true,
        group: '',
        loop: false,
        arrowKeys: true,
        navigateCaption: true,
        navigateArrows: true, // Boolean, 'closeToModal', 'closeScreenEdge'
        history: false,
        restoreDefaultContent: false,
        autoOpen: 0, // Boolean, Number
        bodyOverflow: false,
        fullscreen: true,
        openFullscreen: false,
        closeOnEscape: true,
        closeButton: true,
        appendTo: 'body', // or false
        appendToOverlay: 'body', // or false
        overlay: true,
        overlayClose: true,
        overlayColor: 'rgba(0, 0, 0, 0.8)',
        timeout: false,
        timeoutProgressbar: false,
        pauseOnHover: false,
        timeoutProgressbarColor: 'rgba(255,255,255,0.5)',
        transitionIn: 'fadeIn',
        transitionOut: 'fadeOut',
        transitionInOverlay: 'fadeIn',
        transitionOutOverlay: 'fadeOut',
        onFullscreen: function(){},
        onResize: function(){},
        onOpening: function(){},
        onOpened: function(){},
        onClosing: function(){},
        onClosed: function(){},
        afterRender: function(){}
    });




}));
